import combineReducers from 'react-combine-reducers';
// import { actionTypes as optionsActionTypes } from '../actions/options';
// import { actionTypes as teamsActionTypes } from '../actions/teams';
import { actionTypes as statusActionTypes } from '../actions/status';
// import teamData from '../data/teamsByYear';
// import { getTeamLogo } from '../lib';

const statusInitialState = {
    step: 1,
    rankedPlayers: [
        
    ],
};

export const statusReducer = function(state, action){
    switch(action.type){
        case statusActionTypes.addPlayer:
            return {
                ...state,
                rankedPlayers: [...state.rankedPlayers, {...action.rankedPlayer} ],
            }
        default:
            return state;
    }
}

const playersInitialState = {
    data: [],
};

export const playersReducer = function(state, action){
    switch(action.type){
        default:
            return state;
    }
}

export const rankingsReducer = combineReducers({
    status: [statusReducer, statusInitialState],
    players: [playersReducer, playersInitialState],
});

